import { Component } from '@angular/core';
import { NotificationService } from '../../Model/Notification/notification.service';
import { SessionService } from '../../Util/Session/session.service';
import { CommonService } from '../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  isDisabled: boolean = false;
  Notifications = [] as any;
  user: any;

  constructor(
    private session: SessionService,
    private notification: NotificationService,
    protected common: CommonService,
    private toast: ToastService,
    private router: Router,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.Notification_GetAllSelect('All');
  }

  Notification_GetAllSelect(SelectType: String) {
    this.notification.Notification_GetAllSelect({ SelectType: SelectType, UserType: this.user.UserType, CreatedFor: this.user.UserId }).subscribe({
      next: (response) => {
        if (SelectType == 'All') {
          this.Notifications = response.Table;
          this.common.NotificationCount = response.Table.filter((e: any) => !e.IsRead).length;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ESS_NotificationInsertUpdate(id: any, isAction = false) {
    this.notification.ESS_NotificationInsertUpdate({ SelectType: 'U', WEBESSNotificationId: id, UserType: this.user.UserType, EmpMasterId: this.user.UserId, IsRead: true }).subscribe({
      next: (response) => {
        if (response.Error_Code == '255') {
          if (id == 'All') {
            this.common.NotificationCount -= 0;
            this.Notifications.map((e: any) => e.IsRead = true);
          } else {
            this.common.NotificationCount -= 1;
            this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['IsRead'] = true;
          }
          if (!isAction) {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            if (this.user.UserType == 'A') {
              if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
                this.router.navigate(['todo/leaveapproval/detail/',this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
              } else if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
                this.router.navigate(['todo/regularizationapproval/detail/',this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
              } else if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
                this.router.navigate(['todo/attendanceapproval/detail/',this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
              } else {
                this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
              }
            } else if (this.user.UserType == 'E') {
              if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
                this.router.navigate(['request/leave/']);
              } else if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
                this.router.navigate(['request/regularization/']);
              } else if (this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
                this.router.navigate(['request/attendance/']);
              } else {
                this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
              }
            } else {
              this.toast.show({ message: 'Unauthorized access', type: toastTypeEnum.warning });
            }
          }
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
}

